import { formatCurrency, formatDecimal } from '../utils/format';

export const Metrics = [
  _TL_('Clicks'),
  _TL_('Impressions'),
  _TL_('Spend'),
];

export const YourMetrics = [
  {
    key: 'YourClicks',
    value: _TL_('Your clicks'),
    formatter: formatDecimal,
  },
  {
    key: 'YourImpressions',
    value: _TL_('Your impressions'),
    formatter: formatDecimal,
  },
  {
    key: 'YourSpend',
    value: _TL_('Your spend'),
    formatter: formatCurrency,
  },
];

export const AllMetricNames = {
  SearchInterest: _TL_('Search interest'),
  YourImpressions: _TL_('Your impressions'),
  YourClicks: _TL_('Your clicks'),
  YourSpend: _TL_('Your spend'),
  LastYear: _TL_('Last year'),
};
